import Articles from "../../../pages/fanclub/article/Articles";
import {getFanclubArticlesRoute} from "./factory/content";

const routes = [
    {
        path: getFanclubArticlesRoute(),
        component: Articles,
        exact: false,
        type: 'route',
        loginRequired: true,
    },
];

export default routes;